import React from "react";

export interface ModalHeaderProps {
  title?: string;
  onClose?: () => void;
  showCloseButton?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  showCloseButton = true,
  className = "",
  children,
}) => {
  return (
    <div className={`flex items-center justify-between p-6 border-b border-zinc-800 ${className}`}>
      <div className="flex-1">
        {title && (
          <h2 id="modal-title" className="text-xl font-semibold text-amber-400 tracking-wide">
            {title}
          </h2>
        )}
        {children}
      </div>
      {showCloseButton && onClose && (
        <button
          onClick={onClose}
          className="ml-4 text-zinc-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-amber-400 p-1"
          aria-label="Close modal"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ModalHeader;
